import React from "react";

import routes from "../../../../routes";
import { Icon, ICONS } from "../../../../components/Icons";
import { EFR_COMPLETED_MESSAGES } from "../../../../constants";

import { useLayoutParams } from "../../../FormLayout";
import { useViewId } from "../../../../utils/useViewId";
import { useFormNavigation } from "../../../../components/FormNavigation/FormNavigationProvider";
import { useTrackingHistory } from "../../../../utils/useTrackingHistory";

import { Footer } from "../../../../components/Footer";
import { NextStepButton } from "../../../../components/Buttons/NextStepButton";

import { StyledROinviteEfrSuccessScreen } from "./styled";

export const RoInviteEFRSuccessScreen = () => {
  useFormNavigation([true, false]);
  useLayoutParams(false);
  useViewId(false);
  const pushHistory = useTrackingHistory();

  const closeBtnClick = () => {
    pushHistory(routes.comeBackLogin);
  };

  return (
    <StyledROinviteEfrSuccessScreen>
      <div className="roInviteEfrSuccessWrapper">
        <Icon className="arrowIcon" alt="collapse-icon" name={ICONS.verificationComplete} />
        <div>
          <h2 className="title">Verification complete!</h2>
          <p className="description">{EFR_COMPLETED_MESSAGES}</p>
        </div>
      </div>
      <Footer extraClasses={"oneElement"}>
        <NextStepButton
          withRightArrow={false}
          type="button"
          onClick={() => closeBtnClick()}
          label={"Okay, close"}
          justify="flex-end"
        />
      </Footer>
    </StyledROinviteEfrSuccessScreen>
  );
};
